// extracted by mini-css-extract-plugin
export default {"wrapper":"Xp-z","response":"Yp-z","error":"Zp-z","disabled":"_p-z","buttons":"aq-z","feedbackQuestionSection":"bq-z","yesNoWrapper":"cq-z"};